<template>
  <div>
    <TopBoardJobs
      :is-no-cv-page="isNoCvPage"
      ref="topBoardJobs"
      :num-of-jobs="numOfJobs"
      :filters="filters"
      :search-properties="searchProperties"
      :is-loading="isLoading"
      :is-hot-jobs="hotJobs ? true : false"
    />

    <v-container class="jobs-wrap">
      <div class="section_inner">
        <h1 class="search-title display-16 pr-3 pb-2 font-weight-medium" >
         <span > {{ seodata.searchHeader }}</span>
        </h1>
        <!-- <ArticleBreadcrumbs :items="seodata.breadcrumbs" class="pt-0" v-show="seodata.breadcrumbs.length>1"/> -->
          <!-- temporary until using microservice data -->
          <ArticleBreadcrumbsLegacy :items="seodata.breadcrumbs" class="pt-0" v-show="seodata.breadcrumbs.length>1" />
        <CategoryDescription
          v-show="seodata.categoryDescription"
          :text="seodata.categoryDescription"
          class="mt-n4 py-2 pb-sm-4 pr-3"
        />

        <SectionHotJobs
          :hot-jobs="hotJobs"
          v-show="!isLoading"
          :max-jobs="4"
          :is-load-more-banner="false"
        />
        <JobsOnDrushim
          :is-no-cv-page="isNoCvPage"
          :items="searchRes"
          :num-of-jobs="numOfJobs"
          :recommended-jobs="recommendedJobs"
          :suggestions="searchSuggestions"
          :search-properties="searchProperties"
          :is-loading="isLoading"
          :extentionResultList="extentionResultList"
          :showSeparator="showSeparator"
          :hot-jobs="nextPageHotJobs"
          v-if="!isLoading"
        />

        <DrBtn
          v-if="showButton && !isLoading"
          type-btn="load_jobs_btn "
          :action="loadMore"
          :loader="loading"
        >
          {{ SearchParams.Constants.LoadMoreButtonText }}
        </DrBtn>
      </div>
      <transition name="fade">
        <Spinner v-show="isLoading" />
      </transition>
      <JapuSearchDialog
        v-if="ShowJAPU"
        :is-loading="isLoading"
        :JAPUProperties="JAPUProperties"
      />
      <CvConfirmation />
    </v-container>
  </div>
</template>

<script>
import CvConfirmation from '@/components/Dialogs/CvConfirmation/CvConfirmation';
import drushim_lodash from 'lodash';
import gtm from '@/lib/gtm';
import SearchParams from '@/lib/enums/SearchParams';
import Spinner from '@/components/Spinner/Spinner';
import { checkForRouteQueries, checkForRouteParams } from '@/lib/jobsList';
import TopBoardJobs from '@/components/Jobs_List/TopBoardJobs';
import CategoryDescription from '@/components/Jobs_List/CategoryDescription';
import SectionHotJobs from '@/components/Jobs_List/SectionHotJobs';
import JobsOnDrushim from '@/components/Jobs_List/Jobs_On_Drushim/JobsOnDrushim';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import JapuSearchDialog from '@/components/Japu/JapuSearchDialog';
import { JOB_SEARCH, JOB_SEARCH_SSA } from '@/lib/api.js';

export default {
  layout: 'innerPage',
  name: 'JobsPage',
  mixins: [SeoOptimization],
  components: {
    CvConfirmation,
    TopBoardJobs,
    CategoryDescription,
    SectionHotJobs,
    JobsOnDrushim,
    Spinner,
    JapuSearchDialog
  },

  props: {
    isNoCvPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      bottom: false,
      loadMoreBtn: false,
      loading: false,

      searchRes: [],
      numOfJobs: 0,
      nextPage: undefined,
      numOfPages: undefined,
      recommendedJobs: [],
      hotJobs: [],
      nextPageHotJobs: [],
      nextPageMaxHotJobs: 3,
      loginUser: false,
      localSearchStr: undefined,
      isAA: true,
      filters: undefined,
      searchProperties: undefined,
      searchSuggestions: undefined,
      ssaData: [],
      SearchParams: SearchParams,

      extentionResultList: undefined,
      showSeparator: undefined,
      timer: undefined,
      japuTimeout: null,
      japuDisplayDelay: 1500,
      openJapuDialog: null,
      ShowJAPU: null,
      JAPUProperties: null
    };
  },

  async fetch() {
    try {
      const requestUrl = this.getSearchRequest();
      const { data } = await this.$axios.get(
        encodeURI(`${JOB_SEARCH}?${requestUrl}`)
      );

      this.searchRes = data.ResultList;
      this.numOfJobs = data.TotalSearchResultCount;
      this.count = data.Count;

      this.nextPage = data.NextPageNumber;
      this.numOfPages = data.TotalPagesNumber;
      this.recommendedJobs = data.RecommendedJobs;
      this.hotJobs = data.HotJobs;
      this.localSearchStr = requestUrl;
      this.ssaData = ['update'];
      this.filters = data.Filters;
      this.searchProperties = data.SearchProperties;
      this.searchSuggestions = data.SearchSuggestions;
      //ADDING EXTENTION RESULTS
      this.extentionResultList = data.ExtentionResultList;
      this.showSeparator = data.SearchProperties.showSeparator;

      this.seodata.metaData = data.SEO.MetaDataItems;
      this.seodata.pageTitle = data.SEO.title;
      this.seodata.breadcrumbs = data.SEO.BreadCrumbs.Keys;
      this.seodata.searchHeader = data.SEO.SearchHeader;
      this.seodata.categoryDescription = data.SEO.CategoryDescription;
      this.seodata.canonicalUrl = data.SEO.CanonicalUrl;
      this.JAPUProperties = data.JAPUProperties;
      this.ShowJAPU = data.JAPUProperties.ShowJAPU;
    } catch (error) {
      console.log('error in jobs search: ', error);
    }
  },

  head() {
    return {
      link: [
        {
          /** canonical on jobs page genrated by nuxt  */
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData
    };
  },

  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },
    updateSsa() {
      return this.ssaData && this.ssaData.length > 0;
    },

    isLoading() {
      return this.$fetchState.pending;
    },

    showButton() {
      return this.areMoreJobs();
    }
  },

  watch: {
    ShowJAPU() {
      this.openJapu();
    },
    async $route(to, from) {
      if (to.query.user_s) return;
      await this.$fetch();
    },

    bottom(bottom) {
      if (bottom && this.loadMoreBtn != true) {
        this.loadMore();
      }
    },

    displayLoadMoreButton(val) {
      this.loadMoreBtn = val;
    },

    searchRes() {
      if (this.searchRes) {
        this.fireGtmEvent(this.searchRes);
      }
    },
    /** Recommender impression event  */
    recommendedJobs() {
      if (this.recommendedJobs.length > 0) {
        const dataLayer = {
          category: 'recommender',
          event: 'drushim_recommender',
          action: 'recommender impression',
          cd70: 'recommender_Search Results',
          search: this.searchProperties.WhatFieldText
        };
        gtm(dataLayer);
      }

      /**push recommended jobs to cookies */
      const options = {
        sameSite: 'Lax'
      };

      let cookieList = [];
      for (let index = 0; index < this.recommendedJobs.length; index++) {
        const element = this.recommendedJobs[index].Code;
        cookieList.push({
          name: 'drushim-jID-' + element,
          value: element,
          opts: options
        });
      }
      this.$cookies.setAll(cookieList);
    },

    updateSsa: {
      handler() {
        if (this.updateSsa) {
          this.getSsaData();
        }
      }
    }
  },

  mounted() {
    this.timer = setTimeout(this.goTop, 200);
  },

  methods: {
    sendSSA(evenData) {
      this.ssaData = [];
      const ssaObjectData = JSON.parse(JSON.stringify(evenData));
      this.ssa.logResponse('LogSSA', ssaObjectData);
    },
    // this boolean is an indicator for the 'loading' component in the 'JobsOnDrushim'
    areMoreJobs() {
      return this.nextPage > -1 && this.numOfPages > this.nextPage;
    },

    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    openJapu() {
      if (this.ShowJAPU)
        this.japuTimeout = setTimeout(() => {
          gtm({
            interaction: 'impression',
            event: 'japu'
          });
        }, this.japuDisplayDelay);
    },
    /**
     *  @param {Object} data.ResultList
     *  @function sortGtmData return the Object with required keys
     */
    fireGtmEvent(dataLayer) {
      const _jobJobAnalytics = this.sortGtmData(dataLayer);
      const _dataLayer = {
        event: 'drushim_ee',
        ecommerce: {
          currencyCode: 'ILS',
          impressions: _jobJobAnalytics
        }
      };

      const dataLayerSearch = {
        category: 'search',
        action: this.searchProperties.WhatFieldText,
        event: 'search'
      };
      // gtm(_dataLayer);
      gtm(dataLayerSearch);

      gtm(_dataLayer);
    },
    /**
     * picks GTM dataLayer keys
     * @param {Object} data
     * @return {Object} by required keys
     */
    sortGtmData(data) {
      const gtmJobsData = data.map(obj => {
        const picks = drushim_lodash.pick(obj.JobAnalytics, [
          'id',
          'name',
          'price',
          'dimension22',
          'brand',
          'category',
          'position',
          'quantity',
          'list',
          'dimension15',
          'dimension16',
          'ppcd',
          'dimension17',
          'dimension18',
          'paidresult',
          'dimension19',
          'metric1',
          'dimension20',
          'dimension21',
          'preferred'
        ]);
        return picks;
      });
      return gtmJobsData;
    },

    async loadMore() {
      if (this.areMoreJobs) {
        this.loading = true;
        const search = this.localSearchStr;

        const { data } = await this.$axios.get(
          `${JOB_SEARCH}?${search}&page=${this.nextPage}&isAA=true`
        );

        let res = data;
        if (res.ResultList.length > 0) {
          let nextItems = res.ResultList;
          let existedItems = [];
          if (!drushim_lodash.isEmpty(this.searchRes)) {
            existedItems = this.searchRes;

            let currResults = [...existedItems, ...nextItems];
            this.searchRes = currResults;
          }
        }

        if (res.ExtentionResultList.length > 0) {
          const newExtentionResultList = res.ExtentionResultList;
          this.extentionResultList = [
            ...this.extentionResultList,
            ...newExtentionResultList
          ];
        }

        this.numOfPages = res.TotalPagesNumber;
        this.nextPage = res.NextPageNumber;

        this.nextPageHotJobs = res.HotJobs.slice(0, this.nextPageMaxHotJobs);

        this.ssaData = ['update'];
        this.searchProperties = res.SearchProperties;
        this.loading = false;

        /**
         * Fire GTM event on search results
         * @param {Object} res.ResultList jobs results
         */
        this.fireGtmEvent(res.ResultList);
      }
    },

    getSearchRequest() {
      let tempStr;
      let { query, params } = this.$route;
      let paramData;
      let searchStr = '';

      if (!drushim_lodash.isEmpty(params)) {
        paramData = checkForRouteParams(drushim_lodash.clone(params));
        ({ searchStr } = paramData); // destructing to the declard let searchStr
      }
      if (Object.getOwnPropertyNames(query).length > 0) {
        tempStr = checkForRouteQueries(query);
        searchStr = searchStr.concat('&', tempStr);
      }
      //integrating AA tests
      const aaTestParam = `&isAA=true`;

      return `${searchStr}${aaTestParam}`;
    },

    async getSsaData() {
      try {
        let requestUrl = this.getSearchRequest();
        requestUrl += `&page=${this.searchProperties.CurrentPageNumber}`;

        const postData = {
          JobCodes: this.searchRes.map(j => j.Code),
          HotJobCodes: this.hotJobs.map(j => j.Code),
          RecommendedJobCodes: this.recommendedJobs.map(j => j.Code),
          TotalNumberOfResults: this.numOfJobs
        };

        const { data } = await this.$axios.post(
          encodeURI(`${JOB_SEARCH_SSA}?${requestUrl}`),
          postData
        );

        this.sendSSA(data.SSAEvents);
      } catch (e) {
        console.log('getssadata error', e);
      }
    }
  },
  beforeDestroy() {
    this.loginUser = false;
    clearTimeout(this.timer);
    clearTimeout(this.japuTimeout);
  }
};
</script>

<style lang="scss" scoped>
.jobs-wrap {
  min-height: 900px;
}
.login-popup {
  z-index: 1200 !important;
  top: 30%;
  left: 30%;
  display: flex;
}
.search-title {
  line-height: 24px;
  text-align: right;
}

@media screen and (max-width: 959px) {
  .search-title {
    margin: 0;
    padding: 0;
  }
}
</style>
